const readMoreLinks = document.querySelectorAll('.read-more__btn');

[...readMoreLinks].forEach((readMoreLink) => {
    readMoreLink.addEventListener('click', () => {
        if (readMoreLink.classList.contains('active')) {
            readMoreLink.classList.remove('active');
        } else {
            readMoreLink.classList.add('active');
        }
    });
});
